module.exports = __webpack_public_path__ + "static/img/10_1.8462890d.jpg";